import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EvaButtonGhost} from "./eva-button-ghost";

@Component({
    selector: 'eva-button-ghost',
    templateUrl: './eva-button-ghost.component.html',
})
export class EvaButtonGhostComponent implements OnInit {

    @Input() buttonGhost: EvaButtonGhost;
    @Output() action:EventEmitter<any> = new EventEmitter<any>();
    //@Input() icon;

    constructor() {
    }

    ngOnInit(){
        if(this.buttonGhost.icon){
            this.buttonGhost.icon.name = 'eva-3-icon-'+ this.buttonGhost.icon.name;
        }
        if(this.buttonGhost.icon == undefined){
            this.buttonGhost.icon = {
                visible: false,
                name: ''
            };
        }
    }

    callback(){
        this.action.next();
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/eva-button-ghost/eva-button-ghost.component.ts